<template>
  <section class="access-restricted" :class="{ 'access-restricted--compact': compact }">
    <div class="access-restricted__panel">
      <div class="access-restricted__icon" aria-hidden="true">
        <span class="material-icons-outlined">{{ icon }}</span>
      </div>
      <div class="access-restricted__content">
        <p class="access-restricted__eyebrow">{{ eyebrow }}</p>
        <h2 class="access-restricted__title">{{ title }}</h2>
        <p class="access-restricted__message">{{ message }}</p>
      </div>
      <div v-if="showAction" class="access-restricted__actions">
        <a
          v-if="showSecondaryAction"
          class="access-restricted__button access-restricted__button--secondary"
          :href="secondaryActionHref"
          :target="secondaryActionTarget"
          rel="noreferrer"
        >
          {{ secondaryActionLabel }}
        </a>
        <a class="access-restricted__button" :href="actionHref">
          {{ actionLabel }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AccessRestricted',
  props: {
    title: {
      type: String,
      default: 'Acceso no incluido'
    },
    message: {
      type: String,
      default: 'Tu plan actual no incluye acceso a esta herramienta.'
    },
    eyebrow: {
      type: String,
      default: 'Herramienta bloqueada'
    },
    icon: {
      type: String,
      default: 'lock'
    },
    actionLabel: {
      type: String,
      default: 'Ver planes'
    },
    actionHref: {
      type: String,
      default: '/app/store'
    },
    showAction: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    showSecondaryAction: {
      type: Boolean,
      default: false
    },
    secondaryActionLabel: {
      type: String,
      default: ''
    },
    secondaryActionHref: {
      type: String,
      default: ''
    },
    secondaryActionTarget: {
      type: String,
      default: '_self'
    }
  }
}
</script>

<style lang="scss" scoped>
.access-restricted {
  min-height: calc(100vh - 160px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--color-text-primary);
}

.access-restricted--compact {
  min-height: 360px;
}

.access-restricted__panel {
  width: 100%;
  max-width: 680px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 20px;
  align-items: center;
  padding: 26px;
  border: 1px solid var(--color-outline);
  border-radius: 8px;
  background: var(--color-background);
  box-shadow: 0 12px 28px rgba(15, 15, 26, 0.08);
}

.access-restricted__icon {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--color-active-surface);
  color: var(--color-highlight);
}

.access-restricted__icon .material-icons-outlined {
  font-size: 24px;
}

.access-restricted__eyebrow {
  margin: 0 0 6px;
  color: var(--color-text-secondary);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}

.access-restricted__title {
  margin: 0 0 8px;
  color: var(--color-text-primary);
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.25;
}

.access-restricted__message {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 0.98rem;
  line-height: 1.55;
}

.access-restricted__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.access-restricted__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 18px;
  border: 1px solid var(--color-highlight);
  border-radius: 8px;
  background: var(--color-highlight);
  color: var(--color-text-on-highlight);
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;
}

.access-restricted__button:hover {
  transform: translateY(-1px);
  filter: brightness(1.04);
}

.access-restricted__button--secondary {
  background: var(--color-background);
  color: var(--color-highlight);
}

@media (max-width: 760px) {
  .access-restricted {
    align-items: flex-start;
    padding: 24px 16px;
  }

  .access-restricted__panel {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 22px;
  }

  .access-restricted__actions {
    justify-content: stretch;
  }

  .access-restricted__button {
    width: 100%;
  }
}
</style>
